// @core/api/endpoints/secret/update_encryption_key_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EncryptionKeyResponse,
  UpdateEncryptionKeyConfigRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Update encryption key config
 * Updates key configuration: min_decryption_version, min_encryption_version, deletion_allowed, exportable, auto_rotate_seconds.
 */
export async function UpdateEncryptionKeyConfig(
  engine_id: string,
  key_name: string,
  data: UpdateEncryptionKeyConfigRequest,
  options?: RequestOptions
): Promise<EncryptionKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/keys/:key_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':key_name', encodeURIComponent(key_name));
  const requestOptions = options;
  return client.patch<EncryptionKeyResponse>(requestPath, data, requestOptions);
}
